import axios from "axios";

import { IPeriodLevel } from "backend/model/model";
import { ProjectValues } from "./ProjectForm/index.dto";
//import { mapProjectToWorkflow } from "./dataMapper";
import { mapProjectToWorkflow } from "./dataMapping/dataMapperProject";

const initiateMapping = async (
  values: ProjectValues,
  meaId: string,
  periodLevels: IPeriodLevel[],
  valueSettings: any[]
) => {
  const data = mapProjectToWorkflow(values, meaId, periodLevels, valueSettings);
  console.log("data before mapping: ", values);
  console.log("data after mapping:", data);
  return data;
};

export const ApproveProjectForm = async (
  wfid: string,
  values: ProjectValues,
  periodlevels: IPeriodLevel[],
  valueSettings: any[],
  initialValues: ProjectValues,
  allowedit: boolean,
  meaId: string
) => {
  if (!allowedit || initialValues === values) {
    const res = await axios
      .put(`workflow/instances/${wfid}`, {
        transition: "APPROVE",
      })
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err;
      });
    return res;
  }

  const data = mapProjectToWorkflow(values, meaId, periodlevels, valueSettings);

  const res = await axios
    .put(`workflow/instances/${wfid}`, {
      transition: "APPROVE",
      parameters: data.parameters,
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return res;
};

export const RejectProjectForm = async (wfid: string) => {
  const res = await axios
    .put(`workflow/instances/${wfid}`, {
      transition: "REJECT",
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return res;
};

const SubmitProjectForm = async (
  values: ProjectValues,
  wfid: string,
  meaId: string,
  periodLevels: IPeriodLevel[],
  valueSettings: any[],
  isAdmin: boolean
): Promise<{ status: string; wfid?: string | undefined }> => {
  const data = mapProjectToWorkflow(values, meaId, periodLevels, valueSettings);

  const res = wfid
    ? await axios
        .put(`workflow/instances/${wfid}`, {
          transition: "SUBMIT",
          parameters: data.parameters,
        })
        .then((result) => result)
        .catch((err) => err.response)
    : await axios
        .post(isAdmin ? "workflow/directupdate" : "workflow/instances", {
          ...data,
          elementType: "Initiative",
        })
        .then((result) => result)
        .catch((err) => {
          return err.response?.data;
        });
  const { message } = res;

  console.log("KPIs And Projects Management Form", res);
  if (res.status === 201 || res.status === 200) {
    return {
      status: "success",
      wfid: res.data?.data?.wfInstanceId || "",
    };
  }

  if (message.includes("already exists")) {
    return {
      status: "failExists",
    };
  }
  return {
    status: "fail",
  };
};

export default SubmitProjectForm;
